import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=77ffe9e0&scoped=true&lang=pug&"
import script from "./Textarea.vue?vue&type=script&lang=ts&"
export * from "./Textarea.vue?vue&type=script&lang=ts&"
import style0 from "./Textarea.vue?vue&type=style&index=0&id=77ffe9e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ffe9e0",
  null
  
)

export default component.exports